export default __webpack_public_path__ + "static/media/환자용_사전문진.d5d823ae.png";